import { PUBLIC_ASSETS } from '@/configs/public-assets.config';
import { cn } from '@/libs/shadcn';

interface AppSuspenseFallbackProps {
  containerClassName?: string;
}
export default function AppSuspenseFallback({
  containerClassName,
}: AppSuspenseFallbackProps) {
  return (
    <div
      className={cn(
        'fixed inset-0 bg-linear-0 from-secondary to-secondary flex items-center justify-center',
        containerClassName
      )}
    >
      <div>
        <img
          src={PUBLIC_ASSETS.nutriseeFavicon}
          alt="logo"
          className="shrink-0 object-contain size-38"
        />
      </div>
    </div>
  );
}
